import React from 'react';

import ResponsiveContainer from 'components/ResponsiveContainer';
import useDownloadReferentiel from 'hooks/referentiels/useDownloadReferentiel';
import { getCSVEnumWithDisplayableValue } from 'utils/referentielUtils';

import ReferentielExportComponent from './ReferentielExportComponent/ReferentielExportComponent';

import './ReferentielExport.less';

const ReferentielExport: React.FC = () => {
  const { status, downloadCsv } = useDownloadReferentiel();

  const referentialEnumCSV = getCSVEnumWithDisplayableValue();

  return (
    <ResponsiveContainer className="ReferentielExport">
      <h1>Export des référentiels</h1>
      <p className="description">
        {`Il vous est possible de télécharger les référentiels depuis cette page. 
        Pour cela, il vous suffit de cliquer 
        sur le référentiel que vous voulez télécharger.
        Le fichier généré sera de type CSV.`}
      </p>
      <ReferentielExportComponent
        status={status}
        submit={downloadCsv}
        values={referentialEnumCSV}
      />
    </ResponsiveContainer>
  );
};

export default ReferentielExport;
